export const WORKSPACE_CANVAS_QUERY_KEY = 'canvas';

export const WORKSPACE_CANVAS_MODES = {
  etsySetup: 'etsy-setup',
  etsyImport: 'etsy-import',
  etsyOrders: 'etsy-orders',
  etsyMatching: 'etsy-matching',
  etsyToProduction: 'etsy-to-production',
} as const;

export type WorkspaceCanvasMode =
  | (typeof WORKSPACE_CANVAS_MODES)[keyof typeof WORKSPACE_CANVAS_MODES]
  | null;

export const getWorkspaceCanvasMode = (value: string | null): WorkspaceCanvasMode => {
  if (
    value === WORKSPACE_CANVAS_MODES.etsySetup
    || value === WORKSPACE_CANVAS_MODES.etsyImport
    || value === WORKSPACE_CANVAS_MODES.etsyOrders
    || value === WORKSPACE_CANVAS_MODES.etsyMatching
    || value === WORKSPACE_CANVAS_MODES.etsyToProduction
  ) {
    return value;
  }
  return null;
};
